import { useTheme } from '../../../contexts/ThemeContext';

interface HeaderProps {
  onMenuClick: () => void;
  onSettingsClick: () => void;
  onNewChat: () => void;
  currentStep: number;
  totalSteps: number;
}

export default function Header({ onMenuClick, onSettingsClick, onNewChat }: HeaderProps) {
  const { theme } = useTheme();

  return (
    <header className={`fixed top-0 left-0 right-0 z-30 backdrop-blur-xl border-b ${
      theme === 'dark' 
        ? 'bg-black/40 border-white/10' 
        : 'bg-white/80 border-gray-200'
    }`}>
      <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between">
        {/* Menu Button - Discreto */}
        <button
          onClick={onMenuClick}
          className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
            theme === 'dark'
              ? 'hover:bg-white/5'
              : 'hover:bg-gray-100'
          }`}
        >
          <i className={`ri-menu-line text-lg ${
            theme === 'dark' ? 'text-white/60' : 'text-gray-500'
          }`}></i>
        </button>

        {/* Logo/Nombre centrado */}
        <div className="flex items-center gap-2">
          <div className={`w-7 h-7 rounded-full flex items-center justify-center ${
            theme === 'dark'
              ? 'bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500'
              : 'bg-gradient-to-br from-blue-400 via-purple-400 to-pink-400'
          }`}>
            <i className="ri-chat-3-line text-white text-sm"></i>
          </div>
          <span className={`text-sm font-medium ${
            theme === 'dark' ? 'text-white' : 'text-gray-900'
          }`}>
            AI Assistant
          </span>
        </div>

        {/* Botón reiniciar conversación */}
        <button
          onClick={onNewChat}
          className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
            theme === 'dark'
              ? 'hover:bg-white/5'
              : 'hover:bg-gray-200'
          }`}
          title="Reiniciar conversación"
        >
          <i className={`ri-restart-line text-lg ${
            theme === 'dark' ? 'text-white/60' : 'text-gray-600'
          }`}></i>
        </button>
      </div>
    </header>
  );
}
